import React, { useEffect, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAppContext } from "../context/useAppContext";
import { baseUrl } from "../utils/baseUrl";

const SessionLogin = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const authToken = params.get("auth");
  const navigate = useNavigate();
  const { setUser } = useAppContext();

  const fetchAccount = useCallback(async (authToken) => {
    console.log("SessionLogin: Starting authentication with token", authToken);
    console.log("SessionLogin: Base URL", baseUrl);
    const accountUrl = `${baseUrl}/account`;
    console.log("SessionLogin: Full account URL", accountUrl);

    try {
      const res = await fetch(accountUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        credentials: 'include', // Include credentials for cookie-based auth if needed
        mode: 'cors', // Explicitly set CORS mode
      });

      console.log("SessionLogin: Response status", res.status);

      if (!res.ok) {
        console.error("SessionLogin: Response not OK", res.status, res.statusText);
        return navigate("/");
      }

      const data = await res.json();
      console.log("SessionLogin: Response data", data);

      if (!data?.success) {
        console.error("SessionLogin: API returned success=false", data);
        return navigate("/");
      }

      if (!data?.data) {
        console.error("SessionLogin: No user data in response", data);
        return navigate("/");
      }

      // Set user in context
      setUser({
        user: data.data,
        token: authToken,
      });

      // Set expiration date (24 hours from now)
      const now = new Date();
      const expirationDate = new Date(now.getTime() + 24 * 60 * 60 * 1000);
      localStorage.setItem("expirationDate", expirationDate.toISOString());

      console.log("SessionLogin: Authentication successful, navigating to /account");
      navigate("/account");
    } catch (err) {
      console.error("SessionLogin: Error during authentication", err);
      navigate("/");
    }
  }, [navigate, setUser]);

  useEffect(() => {
    if (!authToken) {
      return navigate("/");
    }

    fetchAccount(authToken);
  }, [authToken, fetchAccount, navigate]);

  return (
    <div
      style={{
        width: "100vw",
        height: "calc(100vh - 74px - 623px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      Authorization in progress...
    </div>
  );
};

export default SessionLogin;
